import script from "./LogoImage.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoImage.vue?vue&type=script&setup=true&lang=js"

import "./LogoImage.vue?vue&type=style&index=0&id=2fec7865&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fec7865"]])

export default __exports__